// extracted by css-extract-rspack-plugin
export default {"intentDetectionContainer":"TasksInChatInput-module__intentDetectionContainer__XZAAG"};